export default "__VITE_ASSET__CREY3dPq__"